const TOKEN_KEY = 'platform_access_token'

let cachedConfig = null

function getApiBaseUrl() {
  return process.env.VUE_APP_API_BASE_URL || ''
}

export function getPlatformAccessToken() {
  return localStorage.getItem(TOKEN_KEY) || ''
}

export function setPlatformAccessToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token)
  else localStorage.removeItem(TOKEN_KEY)
}

export function clearPlatformAccessToken() {
  localStorage.removeItem(TOKEN_KEY)
}

function decodeTokenPayload(token) {
  try {
    const part = token.split('.')[1]
    if (!part) return null
    const json = atob(part.replace(/-/g, '+').replace(/_/g, '/'))
    return JSON.parse(json)
  } catch {
    return null
  }
}

export function isPlatformAccessTokenValid(token = getPlatformAccessToken()) {
  if (!token) return false
  const payload = decodeTokenPayload(token)
  if (!payload || payload.type !== 'platform_access') return false
  if (payload.exp && payload.exp * 1000 <= Date.now()) return false
  return true
}

export function resolveAccessGateHint(config, locale) {
  const lang = String(locale || '').toLowerCase()
  const hintZh = config?.hintZh || config?.hint || ''
  const hintEn = config?.hintEn || config?.hint || ''
  if (lang.startsWith('zh')) return hintZh
  return hintEn || hintZh
}

export async function fetchAccessGateConfig(force = false) {
  if (cachedConfig && !force) return cachedConfig
  const res = await fetch(`${getApiBaseUrl()}/api/system/config`)
  const json = await res.json()
  cachedConfig = json?.data?.accessGate || {
    enabled: false,
    hintZh: '',
    hintEn: '',
    sessionDays: 30
  }
  return cachedConfig
}

export function isAccessGateRequired(config) {
  return !!config?.enabled
}

export function getUrlAccessCode() {
  const params = new URLSearchParams(window.location.search)
  return String(params.get('access') || '').trim()
}

export function stripAccessQueryParam() {
  const url = new URL(window.location.href)
  if (!url.searchParams.has('access')) return
  url.searchParams.delete('access')
  window.history.replaceState({}, '', url.pathname + url.search + url.hash)
}

export async function verifyPlatformAccessCode(code) {
  const res = await fetch(`${getApiBaseUrl()}/api/c/access/verify`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ code: String(code || '').trim() })
  })
  const json = await res.json()
  if (!res.ok || !json.success) {
    const err = new Error(json.message || '授权码错误')
    err.code = json.code || 'ACCESS_CODE_INVALID'
    throw err
  }
  if (json.data?.token) {
    setPlatformAccessToken(json.data.token)
  }
  return json
}

export async function preparePlatformAccess({ forceConfig = false } = {}) {
  const config = await fetchAccessGateConfig(forceConfig)
  if (!isAccessGateRequired(config)) {
    return { granted: true, config }
  }

  if (isPlatformAccessTokenValid()) {
    return { granted: true, config }
  }

  const urlCode = getUrlAccessCode()
  if (/^\d{4}$/.test(urlCode)) {
    try {
      await verifyPlatformAccessCode(urlCode)
      stripAccessQueryParam()
      return { granted: true, config }
    } catch {
      stripAccessQueryParam()
    }
  }

  return { granted: false, config }
}

export function handlePlatformAccessApiError(error) {
  if (error?.code === 'PLATFORM_ACCESS_REQUIRED') {
    clearPlatformAccessToken()
    window.location.reload()
    return true
  }
  return false
}
